module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div'), _vm._v(" "), _c('b-button', {
    staticClass: "mt-1",
    staticStyle: {
      "font-size": "11px"
    },
    attrs: {
      "size": "sm",
      "variant": "outline-info"
    },
    on: {
      "click": function($event) {
        _vm.AssignmentMultiUpdate()
      }
    }
  }, [_c('b', [_vm._v("MultiUpdate")])]), _vm._v(" "), _c('b-modal', {
    ref: "AssignmentMultiUpdate-modal",
    attrs: {
      "id": "AssignmentMultiUpdate-modal",
      "title": _vm.title + _vm.mu_jb_series,
      "size": "xl",
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "hide-footer": ""
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 row"
  }, [_c('div', {
    staticClass: "col-md-4 text-right"
  }, [_c('label', {
    attrs: {
      "for": "ColumnName"
    }
  }, [_vm._v("Assignment Type : ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 mt-2"
  }, [(_vm.multiUpdateDetail.shipmentType) ? _c('b', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.multiUpdateDetail.shipmentType == "1" ||
    _vm.multiUpdateDetail.shipmentType == "Sea_Shipment" ?
    "SEA" :
    "AIR") + _vm._s(" ( " + _vm.multiUpdateDetail.transportType + " )"))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 row"
  }, [_c('div', {
    staticClass: "col-md-4 text-right"
  }, [_c('label', {
    attrs: {
      "for": "ColumnName"
    }
  }, [_vm._v("Column Name")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('model-list-select', {
    attrs: {
      "list": _vm.ColumnNameList,
      "option-value": "ColumnNameVal",
      "option-text": "ColumnNameText",
      "placeholder": "Select Column Name"
    },
    on: {
      "input": function($event) {
        _vm.ChangeColumn(_vm.multiUpdateDetail.ColumnName)
      }
    },
    model: {
      value: (_vm.multiUpdateDetail.ColumnName),
      callback: function($$v) {
        _vm.$set(_vm.multiUpdateDetail, "ColumnName", $$v)
      },
      expression: "multiUpdateDetail.ColumnName"
    }
  }), _vm._v(" "), (!_vm.multiUpdateDetail.ColumnName) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.multiUpdateDetail.ColumnNameError))]) : _vm._e()], 1)]), _vm._v(" "), (_vm.multiUpdateDetail.ColumnName == 'CLIENT') ? _c('div', {
    staticClass: "col-md-6 row"
  }, [_c('div', {
    staticClass: "col-md-4 text-right"
  }, [_c('label', {
    attrs: {
      "for": "ColumnName"
    }
  }, [_vm._v("Client Name")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('model-list-select', {
    attrs: {
      "list": _vm.clientList,
      "id": "clientNamenew",
      "option-value": "clientId",
      "option-text": "clientName",
      "placeholder": "Select Existing Client Name"
    },
    model: {
      value: (_vm.multiUpdateDetail.clientId),
      callback: function($$v) {
        _vm.$set(_vm.multiUpdateDetail, "clientId", $$v)
      },
      expression: "multiUpdateDetail.clientId"
    }
  }), _vm._v(" "), (!_vm.multiUpdateDetail.clientId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.multiUpdateDetail.CommonError) + "\n            ")]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.multiUpdateDetail.ColumnName == 'CLIENT') ? _c('div', {
    staticClass: "col-md-6 row"
  }, [_c('div', {
    staticClass: "col-md-4 text-right"
  }, [_c('label', {
    attrs: {
      "for": "ColumnName"
    }
  }, [_vm._v("Old Client Name")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 mt-2"
  }, [(_vm.allAssignmentMultiUpdateData.length > 0 && _vm.allAssignmentMultiUpdateData[0].clientName) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.allAssignmentMultiUpdateData[0].clientName))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.multiUpdateDetail.ColumnName == 'Importer Client') ? _c('div', {
    staticClass: "col-md-6 row"
  }, [_c('div', {
    staticClass: "col-md-4 text-right"
  }, [_c('label', {
    attrs: {
      "for": "ColumnName"
    }
  }, [_vm._v("Importer Client")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('model-list-select', {
    attrs: {
      "list": _vm.clientList,
      "id": "clientNamenew",
      "option-value": "clientId",
      "option-text": "clientName",
      "placeholder": "Select Existing Importer Client"
    },
    model: {
      value: (_vm.multiUpdateDetail.importerClientId),
      callback: function($$v) {
        _vm.$set(_vm.multiUpdateDetail, "importerClientId", $$v)
      },
      expression: "multiUpdateDetail.importerClientId"
    }
  }), _vm._v(" "), (!_vm.multiUpdateDetail.importerClientId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.multiUpdateDetail.CommonError) + "\n          ")]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.multiUpdateDetail.ColumnName == 'Importer Client') ? _c('div', {
    staticClass: "col-md-6 row"
  }, [_c('div', {
    staticClass: "col-md-4 text-right"
  }, [_c('label', {
    attrs: {
      "for": "ColumnName"
    }
  }, [_vm._v("Old Importer Client")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 mt-2"
  }, [(_vm.allAssignmentMultiUpdateData.length > 0 && _vm.allAssignmentMultiUpdateData[0].clientName) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.allAssignmentMultiUpdateData[0].ImporterClient))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.multiUpdateDetail.ColumnName == 'Exporter Client') ? _c('div', {
    staticClass: "col-md-6 row"
  }, [_c('div', {
    staticClass: "col-md-4 text-right"
  }, [_c('label', {
    attrs: {
      "for": "ColumnName"
    }
  }, [_vm._v("Exporter Client ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('model-list-select', {
    attrs: {
      "list": _vm.clientList,
      "id": "clientNamenew",
      "option-value": "clientId",
      "option-text": "clientName",
      "placeholder": "Select Existing Exporter Client Name"
    },
    model: {
      value: (_vm.multiUpdateDetail.exporterClientId),
      callback: function($$v) {
        _vm.$set(_vm.multiUpdateDetail, "exporterClientId", $$v)
      },
      expression: "multiUpdateDetail.exporterClientId"
    }
  }), _vm._v(" "), (!_vm.multiUpdateDetail.exporterClientId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.multiUpdateDetail.CommonError) + "\n          ")]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.multiUpdateDetail.ColumnName == 'Exporter Client') ? _c('div', {
    staticClass: "col-md-6 row"
  }, [_c('div', {
    staticClass: "col-md-4 text-right"
  }, [_c('label', {
    attrs: {
      "for": "ColumnName"
    }
  }, [_vm._v("Old Exporter Client")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 mt-2"
  }, [(_vm.allAssignmentMultiUpdateData.length > 0 && _vm.allAssignmentMultiUpdateData[0].clientName) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.allAssignmentMultiUpdateData[0].ExporterClient))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (
    _vm.multiUpdateDetail.ColumnName == 'SHIPPING LINE' &&
    _vm.multiUpdateDetail.shipmentType != '2'
  ) ? _c('div', {
    staticClass: "col-md-6 row"
  }, [_c('div', {
    staticClass: "col-md-4 text-right"
  }, [_c('label', {
    attrs: {
      "for": "ColumnName"
    }
  }, [_vm._v(_vm._s(_vm.multiUpdateDetail.containerInfo == "lcl" ? "Agent Coloder" : "Shipping Line"))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [(
    _vm.multiUpdateDetail.shipmentType == '1' &&
    _vm.multiUpdateDetail.multipleContainerType == '15' &&
    _vm.multiUpdateDetail.transportType == 'Export' &&
    _vm.multiUpdateDetail.assign_job_type ?
    _vm.multiUpdateDetail.assign_job_type.indexOf('TPT') >= 0 :
    _vm.multiUpdateDetail.assign_job_type.indexOf('TPT') >= 0 &&
    _vm.multiUpdateDetail.containerInfo == 'lcl'
  ) ? _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllColoaderList'],
      "option-value": "shippingId",
      "option-text": "shippingLine",
      "placeholder": "Select Coloder"
    },
    model: {
      value: (_vm.multiUpdateDetail.shippingId),
      callback: function($$v) {
        _vm.$set(_vm.multiUpdateDetail, "shippingId", $$v)
      },
      expression: "multiUpdateDetail.shippingId"
    }
  }) : _c('model-list-select', {
    attrs: {
      "list": _vm.shippingList,
      "option-value": "shippingId",
      "option-text": "shippingLine",
      "placeholder": "Select Shipping Line"
    },
    model: {
      value: (_vm.multiUpdateDetail.shippingId),
      callback: function($$v) {
        _vm.$set(_vm.multiUpdateDetail, "shippingId", $$v)
      },
      expression: "multiUpdateDetail.shippingId"
    }
  }), _vm._v(" "), (!_vm.multiUpdateDetail.shippingId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n            " + _vm._s(_vm.multiUpdateDetail.CommonError) + "\n            ")]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (
    _vm.multiUpdateDetail.ColumnName == 'SHIPPING LINE' &&
    _vm.multiUpdateDetail.shipmentType != '2'
  ) ? _c('div', {
    staticClass: "col-md-6 row"
  }, [_c('div', {
    staticClass: "col-md-4 text-right"
  }, [_c('label', {
    attrs: {
      "for": "ColumnName"
    }
  }, [_vm._v("Old\n            " + _vm._s(_vm.multiUpdateDetail.containerInfo == "lcl" ?
    "Agent Coloder" :
    "Shipping Line"))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 mt-2"
  }, [(_vm.allAssignmentMultiUpdateData.length > 0 && _vm.allAssignmentMultiUpdateData[0].shippingLine) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.allAssignmentMultiUpdateData[0].shippingLine))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.multiUpdateDetail.ColumnName == 'JOB CHANGE') ? _c('div', {
    staticClass: "col-md-6 row"
  }, [_c('div', {
    staticClass: "col-md-4 text-right"
  }, [_c('label', {
    attrs: {
      "for": "ColumnName"
    }
  }, [_vm._v("JOB")])]), _vm._v(" "), _vm._l((_vm.NewshowSegmentArray), function(segmentNameArray, index) {
    return _c('div', {
      key: index,
      staticClass: "col-md-2",
      attrs: {
        "md-flex": segmentNameArray.flex,
        "md-flex-small": "100"
      }
    }, [_c('md-checkbox', {
      staticClass: "md-primary",
      attrs: {
        "md-value": segmentNameArray.value,
        "name": 'jobType' + (index + 1),
        "id": 'jobType' + (index + 1)
      },
      on: {
        "change": function($event) {
          _vm.jobTypeSelect(segmentNameArray.value, index)
        }
      },
      model: {
        value: (_vm.multiUpdateDetail.jobType[index]),
        callback: function($$v) {
          _vm.$set(_vm.multiUpdateDetail.jobType, index, $$v)
        },
        expression: "multiUpdateDetail.jobType[index]"
      }
    }, [_c('b-badge', {
      attrs: {
        "variant": "light"
      }
    }, [_vm._v(_vm._s(segmentNameArray.value))])], 1), _vm._v(" "), (_vm.newJobType.length <= 0) ? _c('span', {
      staticClass: "error"
    }, [_vm._v("\n            " + _vm._s(_vm.multiUpdateDetail.JobTypeError) + "\n            ")]) : _vm._e()], 1)
  })], 2) : _vm._e(), _vm._v(" "), (_vm.multiUpdateDetail.ColumnName == 'JOB CHANGE') ? _c('div', {
    staticClass: "col-md-6 row"
  }, [_c('div', {
    staticClass: "col-md-4 text-right"
  }, [_c('label', {
    attrs: {
      "for": "ColumnName"
    }
  }, [_vm._v("Old JOB")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 mt-2"
  }, [(_vm.allAssignmentMultiUpdateData.length > 0 && _vm.allAssignmentMultiUpdateData[0].JobTypes) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.allAssignmentMultiUpdateData[0].JobTypes))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.multiUpdateDetail.ColumnName == 'JOB CHANGE') ? _c('div', {
    staticClass: "col-md-6 row"
  }, [(
    _vm.allAssignmentMultiUpdateData.length > 0 && (
      _vm.allAssignmentMultiUpdateData[0].GRDetails ||
      _vm.allAssignmentMultiUpdateData[0].Payment_Status ||
      _vm.allAssignmentMultiUpdateData[0].subscription_status ||
      _vm.allAssignmentMultiUpdateData[0].invoiceNoCreated ||
      _vm.allAssignmentMultiUpdateData[0].Note_Details
    )
  ) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('table', {
    staticClass: "table table-bordered table-sm"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("SN.")]), _vm._v(" "), _c('th', [_vm._v("Subscription Status")]), _vm._v(" "), _c('th', [_vm._v("Payment Status")]), _vm._v(" "), _c('th', [_vm._v("GRN Details")]), _vm._v(" "), _c('th', [_vm._v("Invoice Details")]), _vm._v(" "), _c('th', [_vm._v("Note Details")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("1.")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.allAssignmentMultiUpdateData.length > 0 ? _vm.allAssignmentMultiUpdateData[0].subscription_status : ""))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.allAssignmentMultiUpdateData.length > 0 ? _vm.allAssignmentMultiUpdateData[0].Payment_Status : ""))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.allAssignmentMultiUpdateData.length > 0 ? _vm.allAssignmentMultiUpdateData[0].GRDetails : ""))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.allAssignmentMultiUpdateData.length > 0 ? _vm.allAssignmentMultiUpdateData[0].invoiceNoCreated : ""))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.allAssignmentMultiUpdateData.length > 0 ? _vm.allAssignmentMultiUpdateData[0].Note_Details : ""))])])])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.multiUpdateDetail.ColumnName == 'ENQUIRY ID') ? _c('div', {
    staticClass: "col-md-6 row"
  }, [_c('div', {
    staticClass: "col-md-4 text-right"
  }, [_c('label', {
    attrs: {
      "for": "ColumnName"
    }
  }, [_vm._v("ENQUIRY ID")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['commonDropdownMaster/getAllENQDDList'],
      "option-value": "mainEnquiryId",
      "option-text": "mainEnquirySeries",
      "placeholder": "Select ENQUIRY No"
    },
    model: {
      value: (_vm.multiUpdateDetail.mainEnquiryId),
      callback: function($$v) {
        _vm.$set(_vm.multiUpdateDetail, "mainEnquiryId", $$v)
      },
      expression: "multiUpdateDetail.mainEnquiryId"
    }
  }), _vm._v(" "), (!_vm.multiUpdateDetail.mainEnquiryId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n            " + _vm._s(_vm.multiUpdateDetail.CommonError) + "\n          ")]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.multiUpdateDetail.ColumnName == 'ENQUIRY ID') ? _c('div', {
    staticClass: "col-md-6 row"
  }, [_c('div', {
    staticClass: "col-md-4 text-right"
  }, [_c('label', {
    attrs: {
      "for": "ColumnName"
    }
  }, [_vm._v("Old ENQUIRY ID")])]), _vm._v(" "), (_vm.allAssignmentMultiUpdateData.length > 0) ? _c('div', {
    staticClass: "col-md-8 mt-2"
  }, [(_vm.allAssignmentMultiUpdateData.length > 0 && _vm.allAssignmentMultiUpdateData[0].EnquirySeries) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.allAssignmentMultiUpdateData[0].EnquirySeries))]) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.multiUpdateDetail.ColumnName == 'HANDOVER LOCATION') ? _c('div', {
    staticClass: "col-md-6 row"
  }, [_c('div', {
    staticClass: "col-md-4 text-right"
  }, [_c('label', {
    attrs: {
      "for": "ColumnName"
    }
  }, [_vm._v("Handover Location")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('model-list-select', {
    attrs: {
      "list": _vm.getAlllocationHandover,
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select Handover Location"
    },
    on: {
      "input": function($event) {
        _vm.getLocationList($event, 'All', 'getAlllocationHandover')
      },
      "searchchange": function($event) {
        _vm.getLocationList($event, 'All', 'getAlllocationHandover')
      }
    },
    model: {
      value: (_vm.multiUpdateDetail.handoverLocationId),
      callback: function($$v) {
        _vm.$set(_vm.multiUpdateDetail, "handoverLocationId", $$v)
      },
      expression: "multiUpdateDetail.handoverLocationId"
    }
  }), _vm._v(" "), (!_vm.multiUpdateDetail.handoverLocationId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n            " + _vm._s(_vm.multiUpdateDetail.CommonError) + "\n            ")]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.multiUpdateDetail.ColumnName == 'HANDOVER LOCATION') ? _c('div', {
    staticClass: "col-md-6 row"
  }, [_c('div', {
    staticClass: "col-md-4 text-right"
  }, [_c('label', {
    attrs: {
      "for": "ColumnName"
    }
  }, [_vm._v("Old Handover Location")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 mt-2"
  }, [(_vm.allAssignmentMultiUpdateData.length > 0 && _vm.allAssignmentMultiUpdateData[0].HOV) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.allAssignmentMultiUpdateData[0].HOV))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.multiUpdateDetail.ColumnName == 'PICKUP LOCATION') ? _c('div', {
    staticClass: "col-md-6 row"
  }, [_c('div', {
    staticClass: "col-md-4 text-right"
  }, [_c('label', {
    attrs: {
      "for": "ColumnName"
    }
  }, [_vm._v("Pickup Location")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('model-list-select', {
    attrs: {
      "list": _vm.getAlllocationHandover,
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select Pickup Location"
    },
    on: {
      "input": function($event) {
        _vm.getLocationList($event, 'All', 'getAlllocationHandover')
      },
      "searchchange": function($event) {
        _vm.getLocationList($event, 'All', 'getAlllocationHandover')
      }
    },
    model: {
      value: (_vm.multiUpdateDetail.pickupLocationId),
      callback: function($$v) {
        _vm.$set(_vm.multiUpdateDetail, "pickupLocationId", $$v)
      },
      expression: "multiUpdateDetail.pickupLocationId"
    }
  }), _vm._v(" "), (!_vm.multiUpdateDetail.pickupLocationId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n            " + _vm._s(_vm.multiUpdateDetail.CommonError) + "\n            ")]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.multiUpdateDetail.ColumnName == 'PICKUP LOCATION') ? _c('div', {
    staticClass: "col-md-6 row"
  }, [_c('div', {
    staticClass: "col-md-4 text-right"
  }, [_c('label', {
    attrs: {
      "for": "ColumnName"
    }
  }, [_vm._v("Old Pickup Location")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 mt-2"
  }, [(_vm.allAssignmentMultiUpdateData.length > 0 && _vm.allAssignmentMultiUpdateData[0].PICK) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.allAssignmentMultiUpdateData[0].PICK))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.multiUpdateDetail.ColumnName == 'FACTORY LOCATION') ? _c('div', {
    staticClass: "col-md-6 row"
  }, [_c('div', {
    staticClass: "col-md-4 text-right"
  }, [_c('label', {
    attrs: {
      "for": "ColumnName"
    }
  }, [_vm._v("Factory Location")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['commonDropdownMaster/getAllStuffingList'],
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": _vm.allLocationList.length > 0 ? 'Select Factory Location' : 'No Factory'
    },
    model: {
      value: (_vm.multiUpdateDetail.stuffingLocationId),
      callback: function($$v) {
        _vm.$set(_vm.multiUpdateDetail, "stuffingLocationId", $$v)
      },
      expression: "multiUpdateDetail.stuffingLocationId"
    }
  }), _vm._v(" "), (!_vm.multiUpdateDetail.stuffingLocationId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n            " + _vm._s(_vm.multiUpdateDetail.CommonError) + "\n            ")]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.multiUpdateDetail.ColumnName == 'FACTORY LOCATION') ? _c('div', {
    staticClass: "col-md-6 row"
  }, [_c('div', {
    staticClass: "col-md-4 text-right"
  }, [_c('label', {
    attrs: {
      "for": "ColumnName"
    }
  }, [_vm._v("Old Factory Location")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 mt-2"
  }, [(_vm.allAssignmentMultiUpdateData.length > 0 && _vm.allAssignmentMultiUpdateData[0].STUF) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.allAssignmentMultiUpdateData[0].STUF))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.multiUpdateDetail.ColumnName == 'LP') ? _c('div', {
    staticClass: "col-md-6 row"
  }, [_c('div', {
    staticClass: "col-md-4 text-right"
  }, [_c('label', {
    attrs: {
      "for": "ColumnName"
    }
  }, [_vm._v("Load Port Name")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllPOLList'],
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select POL"
    },
    on: {
      "input": function($event) {
        _vm.getLocationList($event, 'All', 'PortLoadList')
      },
      "searchchange": function($event) {
        _vm.getLocationList($event, 'All', 'PortLoadList')
      }
    },
    model: {
      value: (_vm.multiUpdateDetail.LPlocationId),
      callback: function($$v) {
        _vm.$set(_vm.multiUpdateDetail, "LPlocationId", $$v)
      },
      expression: "multiUpdateDetail.LPlocationId"
    }
  }), _vm._v(" "), (!_vm.multiUpdateDetail.LPlocationId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n            " + _vm._s(_vm.multiUpdateDetail.CommonError) + "\n            ")]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.multiUpdateDetail.ColumnName == 'LP') ? _c('div', {
    staticClass: "col-md-6 row"
  }, [_c('div', {
    staticClass: "col-md-4 text-right"
  }, [_c('label', {
    attrs: {
      "for": "ColumnName"
    }
  }, [_vm._v("Old Load Port Name")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 mt-2"
  }, [(_vm.allAssignmentMultiUpdateData.length > 0 && _vm.allAssignmentMultiUpdateData[0].POL) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.allAssignmentMultiUpdateData[0].POL))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.multiUpdateDetail.ColumnName == 'POR') ? _c('div', {
    staticClass: "col-md-6 row"
  }, [_c('div', {
    staticClass: "col-md-4 text-right"
  }, [_c('label', {
    attrs: {
      "for": "ColumnName"
    }
  }, [_vm._v("Place of Receipt")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllPORList'],
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select POR"
    },
    on: {
      "input": function($event) {
        _vm.getLocationList($event, 'All', 'IcdPOrtList')
      },
      "searchchange": function($event) {
        _vm.getLocationList($event, 'All', 'IcdPOrtList')
      }
    },
    model: {
      value: (_vm.multiUpdateDetail.PORlocationId),
      callback: function($$v) {
        _vm.$set(_vm.multiUpdateDetail, "PORlocationId", $$v)
      },
      expression: "multiUpdateDetail.PORlocationId"
    }
  }), _vm._v(" "), (!_vm.multiUpdateDetail.PORlocationId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n            " + _vm._s(_vm.multiUpdateDetail.CommonError) + "\n            ")]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.multiUpdateDetail.ColumnName == 'POR') ? _c('div', {
    staticClass: "col-md-6 row"
  }, [_c('div', {
    staticClass: "col-md-4 text-right"
  }, [_c('label', {
    attrs: {
      "for": "ColumnName"
    }
  }, [_vm._v("Old Place of Receipt")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 mt-2"
  }, [(_vm.allAssignmentMultiUpdateData.length > 0 && _vm.allAssignmentMultiUpdateData[0].POR) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.allAssignmentMultiUpdateData[0].POR))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.multiUpdateDetail.ColumnName == 'POD') ? _c('div', {
    staticClass: "col-md-6 row"
  }, [_c('div', {
    staticClass: "col-md-4 text-right"
  }, [_c('label', {
    attrs: {
      "for": "ColumnName"
    }
  }, [_vm._v("Port of Discharge")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('model-list-select', {
    attrs: {
      "list": _vm.PortDischargeList,
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select POD"
    },
    on: {
      "input": function($event) {
        _vm.getLocationList(
          $event,
          _vm.allAssignmentMultiUpdateData.length > 0 && (_vm.allAssignmentMultiUpdateData[0].shipmentType == '1' || _vm.allAssignmentMultiUpdateData[0].shipmentType == 'Sea_Shipment') &&
          _vm.allAssignmentMultiUpdateData[0].transportType == 'Export' ?
          'Sea_Port_NonIndia' :
          'Icd,Sea_Port_India',
          'getPortDischargeList'
        )
      },
      "searchchange": function($event) {
        _vm.getLocationList(

          $event,
          _vm.allAssignmentMultiUpdateData.length > 0 && (_vm.allAssignmentMultiUpdateData[0].shipmentType == '1' || _vm.allAssignmentMultiUpdateData[0].shipmentType == 'Sea_Shipment') &&
          _vm.allAssignmentMultiUpdateData[0].transportType == 'Export' ?
          'Sea_Port_NonIndia' :
          'Icd,Sea_Port_India',
          'getPortDischargeList'
        )
      }
    },
    model: {
      value: (_vm.multiUpdateDetail.PODLocationId),
      callback: function($$v) {
        _vm.$set(_vm.multiUpdateDetail, "PODLocationId", $$v)
      },
      expression: "multiUpdateDetail.PODLocationId"
    }
  }), _vm._v(" "), (!_vm.multiUpdateDetail.PODLocationId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n            " + _vm._s(_vm.multiUpdateDetail.CommonError) + "\n            ")]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.multiUpdateDetail.ColumnName == 'POD') ? _c('div', {
    staticClass: "col-md-6 row"
  }, [_c('div', {
    staticClass: "col-md-4 text-right"
  }, [_c('label', {
    attrs: {
      "for": "ColumnName"
    }
  }, [_vm._v("Old Port of Discharge")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 mt-2"
  }, [(_vm.allAssignmentMultiUpdateData.length > 0 && _vm.allAssignmentMultiUpdateData[0].POD) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.allAssignmentMultiUpdateData[0].POD)), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.allAssignmentMultiUpdateData.length > 0) ? _c('label', {
    attrs: {
      "for": "ColumnName"
    }
  }, [_vm._v("BL No:" + _vm._s(_vm.allAssignmentMultiUpdateData[0].PODBLNO))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.multiUpdateDetail.ColumnName == 'FPOD') ? _c('div', {
    staticClass: "col-md-6 row"
  }, [_c('div', {
    staticClass: "col-md-4 text-right"
  }, [_c('label', {
    attrs: {
      "for": "ColumnName"
    }
  }, [_vm._v("Final Place of Delivery")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('model-list-select', {
    attrs: {
      "list": _vm.finalAllPlaceData,
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select FPOD"
    },
    on: {
      "input": function($event) {
        _vm.getLocationList(
          $event,
          _vm.allAssignmentMultiUpdateData.length > 0 && (_vm.allAssignmentMultiUpdateData[0].shipmentType == '1' || _vm.allAssignmentMultiUpdateData[0].shipmentType == 'Sea_Shipment') &&
          _vm.allAssignmentMultiUpdateData[0].transportType == 'Export' ?
          'Sea_Port_NonIndia' :
          'Icd,Sea_Port_India',
          'finalAllPlaceData'
        )
      },
      "searchchange": function($event) {
        _vm.getLocationList(
          $event,
          _vm.allAssignmentMultiUpdateData.length > 0 && (_vm.allAssignmentMultiUpdateData[0].shipmentType == '1' || _vm.allAssignmentMultiUpdateData[0].shipmentType == 'Sea_Shipment') &&
          _vm.allAssignmentMultiUpdateData[0].transportType == 'Export' ?
          'Sea_Port_NonIndia' :
          'Icd,Sea_Port_India',
          'finalAllPlaceData'
        )
      }
    },
    model: {
      value: (_vm.multiUpdateDetail.finalPlaceLocationId),
      callback: function($$v) {
        _vm.$set(_vm.multiUpdateDetail, "finalPlaceLocationId", $$v)
      },
      expression: "multiUpdateDetail.finalPlaceLocationId"
    }
  }), _vm._v(" "), (!_vm.multiUpdateDetail.finalPlaceLocationId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n            " + _vm._s(_vm.multiUpdateDetail.CommonError) + "\n            ")]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.multiUpdateDetail.ColumnName == 'FPOD') ? _c('div', {
    staticClass: "col-md-6 row"
  }, [_c('div', {
    staticClass: "col-md-4 text-right"
  }, [_c('label', {
    attrs: {
      "for": "ColumnName"
    }
  }, [_vm._v("Old Final Place of Delivery")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 mt-2"
  }, [(_vm.allAssignmentMultiUpdateData.length > 0 && _vm.allAssignmentMultiUpdateData[0].FPOD) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.allAssignmentMultiUpdateData[0].FPOD))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.multiUpdateDetail.ColumnName == 'Airport of Destination') ? _c('div', {
    staticClass: "col-md-6 row"
  }, [_c('div', {
    staticClass: "col-md-4 text-right"
  }, [_c('label', {
    attrs: {
      "for": "ColumnName"
    }
  }, [_vm._v("Airport of Destination")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('model-list-select', {
    attrs: {
      "list": _vm.AirPortLoadList,
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select Destination"
    },
    on: {
      "input": function($event) {
        _vm.getLocationList($event, 'Air_Port', 'PortLoadList')
      },
      "searchchange": function($event) {
        _vm.getLocationList($event, 'Air_Port', 'AirPortLoadList')
      }
    },
    model: {
      value: (_vm.multiUpdateDetail.airportDestination),
      callback: function($$v) {
        _vm.$set(_vm.multiUpdateDetail, "airportDestination", $$v)
      },
      expression: "multiUpdateDetail.airportDestination"
    }
  }), _vm._v(" "), (!_vm.multiUpdateDetail.airportDestination) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n            " + _vm._s(_vm.multiUpdateDetail.CommonError) + "\n            ")]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.multiUpdateDetail.ColumnName == 'Airport of Destination') ? _c('div', {
    staticClass: "col-md-6 row"
  }, [_c('div', {
    staticClass: "col-md-4 text-right"
  }, [_c('label', {
    attrs: {
      "for": "ColumnName"
    }
  }, [_vm._v("Old Airport of Destination")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 mt-2"
  }, [(_vm.allAssignmentMultiUpdateData.length > 0 && _vm.allAssignmentMultiUpdateData[0].airDesti) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.allAssignmentMultiUpdateData[0].airDesti))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.multiUpdateDetail.ColumnName == 'Airport of Departure') ? _c('div', {
    staticClass: "col-md-6 row"
  }, [_c('div', {
    staticClass: "col-md-4 text-right"
  }, [_c('label', {
    attrs: {
      "for": "ColumnName"
    }
  }, [_vm._v("Airport of Departure")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('model-list-select', {
    attrs: {
      "list": _vm.AirIcdPOrtList,
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select Airport Departure"
    },
    on: {
      "input": function($event) {
        _vm.getLocationList($event, 'Air_Port', 'IcdPOrtList')
      },
      "searchchange": function($event) {
        _vm.getLocationList($event, 'Air_Port', 'AirIcdPOrtList')
      }
    },
    model: {
      value: (_vm.multiUpdateDetail.airportDeparture),
      callback: function($$v) {
        _vm.$set(_vm.multiUpdateDetail, "airportDeparture", $$v)
      },
      expression: "multiUpdateDetail.airportDeparture"
    }
  }), _vm._v(" "), (!_vm.multiUpdateDetail.airportDeparture) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n            " + _vm._s(_vm.multiUpdateDetail.CommonError) + "\n            ")]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.multiUpdateDetail.ColumnName == 'Airport of Departure') ? _c('div', {
    staticClass: "col-md-6 row"
  }, [_c('div', {
    staticClass: "col-md-4 text-right"
  }, [_c('label', {
    attrs: {
      "for": "ColumnName"
    }
  }, [_vm._v("Old Airport of Departure")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 mt-2"
  }, [(_vm.allAssignmentMultiUpdateData.length > 0 && _vm.allAssignmentMultiUpdateData[0].AirDept) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.allAssignmentMultiUpdateData[0].AirDept))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (
    _vm.multiUpdateDetail.ColumnName == 'Airline' &&
    _vm.multiUpdateDetail.shipmentType == '2'
  ) ? _c('div', {
    staticClass: "col-md-6 row"
  }, [_c('div', {
    staticClass: "col-md-4 text-right"
  }, [_c('label', {
    attrs: {
      "for": "ColumnName"
    }
  }, [_vm._v("Airline")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('model-list-select', {
    attrs: {
      "list": _vm.airLineList,
      "option-value": "airlineId",
      "option-text": "airlineName",
      "placeholder": "Select Airline"
    },
    model: {
      value: (_vm.multiUpdateDetail.airlineId),
      callback: function($$v) {
        _vm.$set(_vm.multiUpdateDetail, "airlineId", $$v)
      },
      expression: "multiUpdateDetail.airlineId"
    }
  }), _vm._v(" "), (!_vm.multiUpdateDetail.airlineId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n            " + _vm._s(_vm.multiUpdateDetail.CommonError) + "\n            ")]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (
    _vm.multiUpdateDetail.ColumnName == 'Airline' &&
    _vm.multiUpdateDetail.shipmentType == '2'
  ) ? _c('div', {
    staticClass: "col-md-6 row"
  }, [_c('div', {
    staticClass: "col-md-4 text-right"
  }, [_c('label', {
    attrs: {
      "for": "ColumnName"
    }
  }, [_vm._v("Old Airline Name")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 mt-2"
  }, [(_vm.allAssignmentMultiUpdateData.length > 0 && _vm.allAssignmentMultiUpdateData[0].airlineName) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.allAssignmentMultiUpdateData[0].airlineName))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.multiUpdateDetail.ColumnName == 'Container Details') ? _c('div', {
    staticClass: "col-md-12 row"
  }, [_c('table', {
    staticClass: "table table-sm table-bordered mt-2"
  }, [_c('tbody', {
    staticStyle: {
      "background": "white"
    }
  }, [(_vm.CONTAINERCOUNTArr.length > 0) ? _c('tr', [_c('th', {
    staticStyle: {
      "width": "5px"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("SN.")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("CONTAINER TYPE")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("CONTAINER No")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "5px"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("\n                Actions\n                ")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.CONTAINERCOUNTArr), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('th', {
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s(index + 1) + ".")]), _vm._v(" "), _c('td', [_c('model-list-select', {
      attrs: {
        "list": _vm.$store.getters['common/getAllContainerTypeList'],
        "option-value": "containerTypeId",
        "option-text": "containerType",
        "placeholder": "Select Container Type"
      },
      on: {
        "input": function($event) {
          _vm.containerTypeChange(item, index)
        }
      },
      model: {
        value: (item.containerTypeId),
        callback: function($$v) {
          _vm.$set(item, "containerTypeId", $$v)
        },
        expression: "item.containerTypeId"
      }
    }), _vm._v(" "), (item.containerTypeId_err ? true : false) ? _c('span', {
      staticClass: "error"
    }, [_vm._v(_vm._s(item.containerTypeId_err))]) : _vm._e()], 1), _vm._v(" "), _c('td', [_c('b-form-input', {
      attrs: {
        "formatter": _vm.capitalizeAll,
        "disabled": _vm.$sessionsStorage.get('nameUser') == 'Bhavneesh' && _vm.$sessionsStorage.get('designation') == 'Admin' ? false : true,
        "type": "text",
        "placeholder": "Enter Container No"
      },
      model: {
        value: (item.containerNo),
        callback: function($$v) {
          _vm.$set(item, "containerNo", $$v)
        },
        expression: "item.containerNo"
      }
    }), _vm._v(" "), (item.containerNo_err ? true : false) ? _c('span', {
      staticClass: "error"
    }, [_vm._v(_vm._s(item.containerNo_err))]) : _vm._e()], 1), _vm._v(" "), _c('td', [(index > 0) ? _c('b-button', {
      attrs: {
        "size": "sm",
        "disabled": ""
      },
      on: {
        "click": function($event) {
          _vm.removeContainerCount(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-minus-circle",
      attrs: {
        "aria-hidden": "true"
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.$sessionsStorage.get('nameUser') == 'Bhavneesh' && _vm.$sessionsStorage.get('designation') == 'Admin') ? _c('b-button', {
      staticClass: "btn btn-sm btn-success",
      attrs: {
        "size": "sm"
      },
      on: {
        "click": function($event) {
          _vm.updateContainerNo(item)
        }
      }
    }, [_vm._v("\n                  Update\n                ")]) : _vm._e()], 1)])
  })], 2)])]) : _vm._e(), _vm._v(" "), (_vm.multiUpdateDetail.ColumnName == 'Booking No (CT JOB)') ? _c('div', {
    staticClass: "col-md-6 row"
  }, [_c('div', {
    staticClass: "col-md-4 text-right"
  }, [_c('label', {
    attrs: {
      "for": "ColumnName"
    }
  }, [_vm._v("Booking No (CT JOB)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "validBookingNo",
      "name": "validBookingNo"
    },
    on: {
      "input": _vm.fetchExistExec
    },
    model: {
      value: (_vm.multiUpdateDetail.validBookingNo),
      callback: function($$v) {
        _vm.$set(_vm.multiUpdateDetail, "validBookingNo", $$v)
      },
      expression: "multiUpdateDetail.validBookingNo"
    }
  }), _vm._v(" "), (!_vm.multiUpdateDetail.validBookingNo) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n            " + _vm._s(_vm.multiUpdateDetail.CommonError) + "\n            ")]) : _vm._e(), _vm._v(" "), _c('h5', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.showSameBookingError))])], 1)]) : _vm._e(), _vm._v(" "), (_vm.multiUpdateDetail.ColumnName == 'Booking No (CT JOB)') ? _c('div', {
    staticClass: "col-md-6 row"
  }, [_c('div', {
    staticClass: "col-md-4 text-right"
  }, [_c('label', {
    attrs: {
      "for": "ColumnName"
    }
  }, [_vm._v("Old Booking No (CT JOB)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 mt-2"
  }, [(
    _vm.allAssignmentMultiUpdateData.length > 0 &&
    _vm.allAssignmentMultiUpdateData[0].validBookingNo
  ) ? _c('b', {
    staticClass: "error"
  }, [_vm._v("\n            " + _vm._s(_vm.allAssignmentMultiUpdateData[0].validBookingNo) + "\n          ")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.multiUpdateDetail.ColumnName == 'Increase Container Count') ? _c('div', {
    staticClass: "col-md-6 row"
  }, [_c('div', {
    staticClass: "col-md-4 text-right"
  }, [_c('label', {
    attrs: {
      "for": "ColumnName"
    }
  }, [_vm._v("Container Count")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "multiConNo",
      "name": "multiConNo"
    },
    model: {
      value: (_vm.multiUpdateDetail.multiConNo),
      callback: function($$v) {
        _vm.$set(_vm.multiUpdateDetail, "multiConNo", $$v)
      },
      expression: "multiUpdateDetail.multiConNo"
    }
  }), _vm._v(" "), (!_vm.multiUpdateDetail.multiConNo) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n            " + _vm._s(_vm.multiUpdateDetail.CommonError) + "\n          ")]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.multiUpdateDetail.ColumnName == 'Increase Container Count') ? _c('div', {
    staticClass: "col-md-6 row"
  }, [_c('div', {
    staticClass: "col-md-4 text-right"
  }, [_c('label', {
    attrs: {
      "for": "ColumnName"
    }
  }, [_vm._v("Old Container Count")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 mt-2"
  }, [(_vm.allAssignmentMultiUpdateData.length > 0 && _vm.allAssignmentMultiUpdateData[0].multiConNo) ? _c('b', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.allAssignmentMultiUpdateData[0].multiConNo))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 text-center"
  }, [_c('center', [(
    _vm.multiUpdateDetail.allModuleId != '' &&
    _vm.multiUpdateDetail.ColumnName != '' &&
    this.multiUpdateDetail.NewJobTypesArr.length >= 1
  ) ? _c('b-button', {
    staticClass: "mt-1 ml-1 mr-1",
    staticStyle: {
      "font-size": "11px"
    },
    attrs: {
      "size": "sm",
      "variant": "success",
      "disabled": _vm.multiUpdateDetail.ColumnName == 'JOB CHANGE' && _vm.buttonDisable ?
        true :
        false
    },
    on: {
      "click": _vm.SaveMultiUpdate
    }
  }, [_vm._v("Save")]) : _vm._e(), _vm._v(" "), _c('b-button', {
    staticClass: "mt-1",
    staticStyle: {
      "font-size": "11px"
    },
    attrs: {
      "size": "sm",
      "variant": "danger"
    },
    on: {
      "click": _vm.hideAssignmentMultiUpdate
    }
  }, [_vm._v("\n            Close")])], 1)], 1)])]), _vm._v(" "), _c('b-modal', {
    ref: "modal-close-conf",
    attrs: {
      "id": "modal-close-conf",
      "title": "Confirmation",
      "centered": "",
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "hide-footer": ""
    }
  }, [_c('h4', {
    staticClass: "error"
  }, [_vm._v("Are You Sure Want To Change Job")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": function($event) {
        _vm.Confirmation('Yes')
      }
    }
  }, [_vm._v(" Yes")]), _vm._v(" "), _c('b-button', {
    staticClass: "pull-right",
    attrs: {
      "variant": "danger"
    },
    on: {
      "click": function($event) {
        _vm.Confirmation('No')
      }
    }
  }, [_vm._v("\n      No")])], 1), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d572a450","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/common/multiUpdate.vue
// module id = 2871
// module chunks = 0